import { ClipboardList, Clock, type LucideIcon } from 'lucide-react';
import { normalizeForSearch } from '@/shared/lib/utils/normalizeForSearch';

export const RELATORIO_ACAO = {
  ATIVIDADES: 2601,
  ACESSOS: 2602,
} as const;

/** Ações que liberam o item Relatórios no menu. Inclua aqui cada 26xx novo. */
export const RELATORIO_ACOES_MENU = [RELATORIO_ACAO.ATIVIDADES, RELATORIO_ACAO.ACESSOS] as const;

export type ModeloRelatorio = {
  id: string;
  rotulo: string;
};

export type RelatorioCatalogo = {
  id: string;
  titulo: string;
  descricao: string;
  acao: number;
  path: string;
  icon: LucideIcon;
  modelos: ModeloRelatorio[];
};

export const RELATORIOS: RelatorioCatalogo[] = [
  {
    id: 'atividades',
    titulo: 'Relatório de atividades',
    descricao: 'Totais, gráficos e, se pedido, a lista das publicações do período.',
    acao: RELATORIO_ACAO.ATIVIDADES,
    path: '/relatorios/atividades',
    icon: ClipboardList,
    modelos: [{ id: 'padrao', rotulo: 'Modelo padrão' }],
  },
  {
    id: 'acessos',
    titulo: 'Relatório de acessos',
    descricao: 'Horas de permanência por criança e por dia, no máximo 31 dias.',
    acao: RELATORIO_ACAO.ACESSOS,
    path: '/relatorios/acessos',
    icon: Clock,
    modelos: [{ id: 'padrao', rotulo: 'Modelo padrão' }],
  },
];

export function relatoriosVisiveis(acoes: number[], consulta: string): RelatorioCatalogo[] {
  const q = normalizeForSearch(consulta);
  return RELATORIOS.filter((relatorio) => {
    if (!acoes.includes(relatorio.acao)) return false;
    if (!q) return true;
    const texto = normalizeForSearch(`${relatorio.titulo} ${relatorio.descricao}`);
    return texto.includes(q);
  });
}

export const TIPOS_PUBLICACAO_RELATORIO = [
  { tipo: 80, rotulo: 'Recado', ver: 801, fazer: 802 },
  { tipo: 90, rotulo: 'Acesso', ver: 901, fazer: 902 },
  { tipo: 100, rotulo: 'Saúde', ver: 1001, fazer: 1002 },
  { tipo: 110, rotulo: 'Soninho', ver: 1101, fazer: 1102 },
  { tipo: 120, rotulo: 'Alimentação', ver: 1201, fazer: 1202 },
  { tipo: 130, rotulo: 'Higiene', ver: 1301, fazer: 1302 },
] as const;

export function tiposPermitidos(acoes: number[]) {
  return TIPOS_PUBLICACAO_RELATORIO.filter(
    (tipo) => acoes.includes(tipo.ver) || acoes.includes(tipo.fazer),
  );
}

export const AGRUPAMENTOS = [
  { value: 'TURMA', label: 'Turma' },
  { value: 'ALUNO', label: 'Aluno' },
  { value: 'DIA', label: 'Dia' },
] as const;

export type AgruparPor = (typeof AGRUPAMENTOS)[number]['value'];
